import { OrderModel } from "../core/_models/order.model";

export function getJsonLocalStorage(key: string): any {
  let dataString = localStorage.getItem(key)
  if (dataString) {
    return JSON.parse(dataString)
  }
  return null
}

export function saveOderLocalStorage(order: OrderModel): any {
  const orderStorage: OrderModel[] = getJsonLocalStorage("order_data") || [];
  const updatedOrders = orderStorage.map((orderMap: any) =>
    orderMap.order_id === order.store_id ? { ...orderMap, ...order } : orderMap
  );
  if (!updatedOrders.find((orderMap) => orderMap.order_id === order.store_id)) {
    updatedOrders.push({ order_id: order.store_id, ...order });
  }
  localStorage.setItem("order_data", JSON.stringify(updatedOrders));
}

export function getOrderLocalStorage(orderDataId: string): any {
  const orderStorage: OrderModel[] = getJsonLocalStorage("order_data") || [];
  const foundOrder = orderStorage.find((order: any) => order.order_id === orderDataId);
  return foundOrder || null;
}

export function removeOrderLocalStorage(orderID: string): void {
  const orderStorage: any[] = getJsonLocalStorage("order_data") || [];
  const updatedOrders = orderStorage.filter(order => order.order_id !== orderID);
  localStorage.setItem("order_data", JSON.stringify(updatedOrders));
}

export function clearJsonLocalStorage(key: string): void {
  localStorage.removeItem(key);
}
